module.exports = __webpack_public_path__ + "images/psp/psplinkscard/5x15.svg";